import { render, staticRenderFns } from "./workContent.vue?vue&type=template&id=c2c969a8&scoped=true&"
import script from "./workContent.vue?vue&type=script&lang=js&"
export * from "./workContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c969a8",
  null
  
)

export default component.exports